import { render, staticRenderFns } from "./CRUD.vue?vue&type=template&id=bb7ef314&scoped=true&"
import script from "./CRUD.vue?vue&type=script&lang=ts&"
export * from "./CRUD.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb7ef314",
  null
  
)

export default component.exports